import React from 'react';
import Title from '../../../../@casino/ui/title';
import { useRouter } from '../../../../@casino/useRouter';
import { useDispatch, useSelector } from 'react-redux';
import { setGetProviders } from '../../../store/games/thunk/setGetProviders';
import ProviderItem from './components/ProviderItem';

const ProvidersList = () => {
    const router = useRouter();
    const dispatch = useDispatch();

    React.useEffect(() => {
        dispatch(setGetProviders({}))
    }, [])

    const providers = useSelector((state) => state.games.providers);

    const handleClick = () => {
        router.history.push('/providers/create');
    }

    return (
        <div style={{ padding: '0 20px' }}>
            <Title
                label="Список провайдеров"
                labelBtn="Добавить провайдера"
                button={handleClick}
            />
            <div style={{display: 'flex', gap: 10, flexWrap: 'wrap'}}>
                {
                    providers.map((item) => (
                        <ProviderItem {...item} />
                    ))
                }
            </div>
        </div>
    )
}

export default ProvidersList;